import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { GoogleAnalytics } from '../../../../services/analytics';
export function createDomEventHandlerType(eventType) {
  return "on".concat(eventType[0].toUpperCase()).concat(eventType.substring(1));
}
export function wrapEventHandler(event, eventType, children) {
  var category = event.category,
    action = event.action,
    label = event.label,
    value = event.value,
    nonInteraction = event.nonInteraction;
  var _children$props = children.props,
    props = _children$props === void 0 ? {} : _children$props;
  var domEventHandlerType = createDomEventHandlerType(eventType);
  var childEventHandler = props[domEventHandlerType];
  return _defineProperty({}, domEventHandlerType, function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            GoogleAnalytics.event(category, action, {
              label: label,
              value: value,
              nonInteraction: nonInteraction
            });
            if (!childEventHandler) {
              _context.next = 4;
              break;
            }
            _context.next = 4;
            return childEventHandler(e);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
}